import { render, staticRenderFns } from "./CurrentTask.vue?vue&type=template&id=34cbcf4e&scoped=true&"
import script from "./CurrentTask.vue?vue&type=script&lang=js&"
export * from "./CurrentTask.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTask.vue?vue&type=style&index=0&id=34cbcf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cbcf4e",
  null
  
)

component.options.__file = "CurrentTask.vue"
export default component.exports